//import { useErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";


const ErrorFallback = ({ error }: any) => {
  const { t } = useTranslation();
  const lochallHomeUrl = String(t('externalUrls.lochall.home'));

  //const { resetBoundary } = useErrorBoundary();

  return (
    <div className="error-container">
      <h1>{t('error.sessionExpired')}</h1>
      <p hidden>{error?.message}</p>
      <p>{t('error.pleaseReconnect')}</p>
      <a type="button" href={lochallHomeUrl}>{t('error.connect')}</a>
    </div>
  );
};

export default ErrorFallback;
